import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    handleExperiences,
    setApplyingWithNewRules,
    setBirthYear,
} from '@/reducers/experiences'
import { AppDispatch, AppState } from '@/types'
import { EXPERIENCE_CHOICES } from '@/utils/constants'
import { Input } from '@/components/UI'
import { Checkbox, Toggle } from '@sonans/components'
import { Text } from '@/components/UI/Text'
import { helperTextAgeAndAddedPoints } from '@/helpers/HelperTexts'
import dataLayer from '@/utils/dataLayer'

const Experiences = () => {
    const experiences = useSelector(
        (state: AppState) => state.experiences.experiences
    )
    const birthYear = useSelector(
        (state: AppState) => state.experiences.birthYear
    )
    const applyingWithNewRules = useSelector(
        (state: AppState) => state.experiences.applyingWithNewRules
    )

    const dispatch = useDispatch<AppDispatch>()

    function handleSetBirthYear(e: React.ChangeEvent<HTMLInputElement>) {
        if (e.target.value.length > 4) return
        dispatch(setBirthYear(e.target.value))
    }

    return (
        <div>
            <section className="flex flex-col mb-4">
                <Text
                    type="title"
                    popupTitle={helperTextAgeAndAddedPoints.title}
                    popupContent={helperTextAgeAndAddedPoints.content}
                >
                    Alders- og tilleggspoeng
                </Text>
                <Text type="body">
                    Fra 2028 endres opptaksreglene til høyere utdanning.
                </Text>
                <Text type="body">
                    Velg når du skal søke høyere utdanning for å få riktig poengsum.
                </Text>
            </section>

            <div className="mb-4">
                <Toggle
                    name="applyingWithNewRules"
                    value={applyingWithNewRules ? '2028' : '2026'}
                    items={[
                        { label: 'Ditt snitt i 2026', value: '2026' },
                        { label: 'Ditt snitt i 2028', value: '2028' },
                    ]}
                    onChange={(value) => dispatch(setApplyingWithNewRules(value === '2028'))}
                />
            </div>

            <div className="flex flex-col gap-2 mb-4">
                {!applyingWithNewRules && (
                    <Input
                        noIcon
                        placeholder="Fødselsår"
                        onChange={handleSetBirthYear}
                        value={birthYear}
                        onBlur={() => {
                            dataLayer.push({
                                event: 'karakterkalkulator_karakterer_fodselsaar',
                                birthyear: birthYear.toString(),
                            })
                        }}
                    />
                )}

                <div className="w-full rounded-xl overflow-hidden border border-gray-200">
                    <div className="flex items-center bg-sonans-new-black text-white px-4 py-2">
                        <Text className="text-white">Tilleggspoeng</Text>
                    </div>
                    <div className="grid grid-cols-2 bg-white px-4 py-3 gap-y-2">
                        {EXPERIENCE_CHOICES.filter((experience) => {
                            if (applyingWithNewRules) {
                                return experience === 'Militæret/siviltjeneste'
                            }
                            return true
                        }).map((choice) => (
                            <Checkbox
                                key={choice}
                                id={choice}
                                label={choice}
                                checked={experiences.includes(choice)}
                                onChange={() => dispatch(handleExperiences(choice))}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Experiences
